// Фиксированные суффиксы путей микросервисов за одним гейтвеем — не зависят от окружения,
// меняется только хост (apiHost).
export function buildApiRoutes(apiHost: string) {
  const identity = `${apiHost}/agrosmart-identity-ws`;
  return {
    base: `${apiHost}/tariff-quota/api`,
    auth: {
      policy: `${identity}/auth/web/policy`,
      me: `${identity}/auth/web/me`,
      farmerLogin: `${identity}/auth/web/farmer/login`,
      staffExchange: `${identity}/auth/web/staff/exchange`,
      logout: `${identity}/auth/web/logout`,
      assignRole: `${identity}/auth/web/assign-role`
    },
    ekyzmat: {
      getOAuthUrl: `${identity}/e-id/login`
    },
    oep: {
      userAuthMethods: `${apiHost}/tariff-quota/oep/user-auth-methods`,
      getPinCode: `${apiHost}/tariff-quota/oep/user-get-pin-code`,
      accountAuth: `${apiHost}/tariff-quota/oep/user-account-auth`
    }
  };
}
